// GENERATED by site/tools/music.ts — do not edit by hand. Re-run the tool after changing the
// source folder (default ~/Downloads/Winamp) and this file is rewritten from the real files.
//
// 41 tracks, 133 minutes. Files are served from public/music/,
// duration and tags read with ffprobe. Kris's playlist, replacing the Webamp demo album.

const album = 'internetcoin.vip';

export const initialTracks = [
  {
    url: '/music/sglilyy-molly-ciroc.mp3',
    duration: 133.524898,
    metaData: {
      title: 'molly Ciroc',
      artist: '@sglilyy',
      album,
    },
  },
  {
    url: '/music/5v-mint-frei.mp3',
    duration: 192.065306,
    metaData: {
      title: 'frei',
      artist: '5v + mint',
      album,
    },
  },
  {
    url: '/music/beansclub-beantrance2.mp3',
    duration: 316,
    metaData: {
      title: 'beantrance2',
      artist: 'beansclub',
      album,
    },
  },
  {
    url: '/music/beansclub-oh-my-god-i-want-that-shit.mp3',
    duration: 389.890612,
    metaData: {
      title: 'oh my god i want that shit',
      artist: 'beansclub',
      album,
    },
  },
  {
    url: '/music/che-get-naked.mp3',
    duration: 108.029388,
    metaData: {
      title: 'GET NAKED',
      artist: 'Che',
      album,
    },
  },
  {
    url: '/music/chief-keef-feat-50-cent-wiz-khalifa-hate-bein-sober.mp3',
    duration: 280.202449,
    metaData: {
      title: 'Hate Bein Sober',
      artist: 'Chief Keef feat. 50 Cent, Wiz Khalifa',
      album,
    },
  },
  {
    url: '/music/chief-keef-feat-rick-ross-3hunna.mp3',
    duration: 208.719433,
    metaData: {
      title: '3Hunna',
      artist: 'Chief Keef feat. Rick Ross',
      album,
    },
  },
  {
    url: '/music/cult-sh-tta-tanboymiguel-block-gets-hot-like-bangkok.mp3',
    duration: 139.637551,
    metaData: {
      title: 'block gets hot like bangkok',
      artist: 'Cult Shφtta, Tanboymiguel',
      album,
    },
  },
  {
    url: '/music/dan-larkin-underscores-ft-8485-your-favorite-sidekick-dan.mp3',
    duration: 168.032653,
    metaData: {
      title: 'Dan Larkin underscores ft 8485 Your Favorite Sidekick Dan',
      artist: '',
      album,
    },
  },
  {
    url: '/music/diegointhedark-hide-my-wrist.mp3',
    duration: 160,
    metaData: {
      title: 'Hide my Wrist',
      artist: 'diegointhedark',
      album,
    },
  },
  {
    url: '/music/drank-spilled-prod-benjahmeenn.mp3',
    duration: 92.375011,
    metaData: {
      title: 'Drank Spilled PROD BENJAHMEENN',
      artist: '',
      album,
    },
  },
  {
    url: '/music/ecco2k-calcium-x-show-me-love.mp3',
    duration: 232.008,
    metaData: {
      title: 'calcium x show me love',
      artist: 'ecco2k',
      album,
    },
  },
  {
    url: '/music/esdeekid-rottweiler.mp3',
    duration: 96.013061,
    metaData: {
      title: 'Rottweiler',
      artist: 'EsDeeKid',
      album,
    },
  },
  {
    url: '/music/euro5tar-newark.mp3',
    duration: 113.655306,
    metaData: {
      title: 'Newark',
      artist: 'Euro5tar',
      album,
    },
  },
  {
    url: '/music/flexin-prod-globoy-kaiser.mp3',
    duration: 122.909093,
    metaData: {
      title: 'flexin prod globoy kaiser',
      artist: '',
      album,
    },
  },
  {
    url: '/music/i-dont-like-chief-keef.mp3',
    duration: 301.270204,
    metaData: {
      title: 'Chief Keef',
      artist: 'I Dont Like',
      album,
    },
  },
  {
    url: '/music/jauz-2-step.mp3',
    duration: 147.2,
    metaData: {
      title: '2 Step',
      artist: 'Jauz',
      album,
    },
  },
  {
    url: '/music/leroy-s3-e9-i-hate-when-boys-lie.mp3',
    duration: 154.057143,
    metaData: {
      title: 'S3 E9 i hate when BOYS lie',
      artist: 'leroy',
      album,
    },
  },
  {
    url: '/music/levels-avicii-skrillex-remix.mp3',
    duration: 273.031837,
    metaData: {
      title: 'Avicii (Skrillex Remix)',
      artist: 'Levels',
      album,
    },
  },
  {
    url: '/music/lil-shine-kissmethrudaphone.mp3',
    duration: 146.546939,
    metaData: {
      title: 'KissMeThruDaPhone',
      artist: 'Lil Shine',
      album,
    },
  },
  {
    url: '/music/lucki-future-kapitol-denim.mp3',
    duration: 117.01551,
    metaData: {
      title: 'KAPITOL DENIM',
      artist: 'LUCKI, Future',
      album,
    },
  },
  {
    url: '/music/lucy-bedroque-g6-anthem.mp3',
    duration: 195.403855,
    metaData: {
      title: 'G6 Anthem',
      artist: 'Lucy Bedroque',
      album,
    },
  },
  {
    url: '/music/lucy-bedroque-mimosa.mp3',
    duration: 166.613424,
    metaData: {
      title: 'Mimosa',
      artist: 'Lucy Bedroque',
      album,
    },
  },
  {
    url: '/music/me.mp3',
    duration: 137.547755,
    metaData: {
      title: 'me',
      artist: '',
      album,
    },
  },
  {
    url: '/music/ninajirachi-porter-robinson-wannacry.mp3',
    duration: 219.402449,
    metaData: {
      title: 'WannaCry',
      artist: 'Ninajirachi, Porter Robinson',
      album,
    },
  },
  {
    url: '/music/nomico-bad-apple.mp3',
    duration: 219.08898,
    metaData: {
      title: '東方 Bad Apple!!',
      artist: 'Nomico',
      album,
    },
  },
  {
    url: '/music/puresnow-rock-bottom.mp3',
    duration: 184.084898,
    metaData: {
      title: 'Rock Bottom',
      artist: 'PureSnow',
      album,
    },
  },
  {
    url: '/music/quest-master-church-of-crystal-power.mp3',
    duration: 202.592653,
    metaData: {
      title: 'Church of Crystal Power',
      artist: 'Quest Master',
      album,
    },
  },
  {
    url: '/music/rocket-rese-miss-my-choppa.mp3',
    duration: 102.4,
    metaData: {
      title: 'MISS MY CHOPPA',
      artist: 'Rocket Rese',
      album,
    },
  },
  {
    url: '/music/serebro.mp3',
    duration: 225.776327,
    metaData: {
      title: 'Мало тебя',
      artist: 'SEREBRO',
      album,
    },
  },
  {
    url: '/music/sg-lily-cryptid.mp3',
    duration: 141.084,
    metaData: {
      title: 'cryptid',
      artist: 'sg lily',
      album,
    },
  },
  {
    url: '/music/sgpwes-cut-ties-prod-overkill.mp3',
    duration: 121.351837,
    metaData: {
      title: 'cut ties prod overkill',
      artist: 'sgpwes',
      album,
    },
  },
  {
    url: '/music/slayr-lucy-bedroque-daytona.mp3',
    duration: 164.375011,
    metaData: {
      title: 'Daytona',
      artist: 'slayr, Lucy Bedroque',
      album,
    },
  },
  {
    url: '/music/studioone-r2r-keygen.mp3',
    duration: 238.050975,
    metaData: {
      title: 'StudioOne R2R Keygen',
      artist: '',
      album,
    },
  },
  {
    url: '/music/t-pazolite-logic-agent.mp3',
    duration: 215.092245,
    metaData: {
      title: 'Logic Agent',
      artist: 't-pazolite',
      album,
    },
  },
  {
    url: '/music/t-pazolite-paranoid.mp3',
    duration: 200.489796,
    metaData: {
      title: 'Paranoid',
      artist: 't-pazolite',
      album,
    },
  },
  {
    url: '/music/virtual-self-angel-voices.mp3',
    duration: 392.281882,
    metaData: {
      title: 'ANGEL VOICES',
      artist: 'Virtual Self',
      album,
    },
  },
  {
    url: '/music/yax03-17-yo-silly-edm-artist-from-japan-vs-the-world.mp3',
    duration: 329.991837,
    metaData: {
      title: '17 yo silly EDM artist from Japan vs. the World',
      artist: 'yax03',
      album,
    },
  },
  {
    url: '/music/yax03-dancing-in-the-90-s-we-ain-t-stopping-till-the-world-e.mp3',
    duration: 329.129796,
    metaData: {
      title: 'yax03 dancing in the 90 s we ain t stopping till the world en',
      artist: '',
      album,
    },
  },
  {
    url: '/music/yeat-lil-uzi-vert-flawless.mp3',
    duration: 161.81551,
    metaData: {
      title: 'Flawless',
      artist: 'Yeat, Lil Uzi Vert',
      album,
    },
  },
  {
    url: '/music/l-touhou-night-of-nights-flowering-nights-r.mp3',
    duration: 191.504739,
    metaData: {
      title: 'ビートまりお l Touhou ナイト オブ ナイツ Night of Nights Flowering nights r',
      artist: '',
      album,
    },
  },
];

/** A different order every load, so a repeat visitor does not hear the same opener twice. */
export function shuffledTracks() {
  const out = initialTracks.slice();
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = out[i];
    out[i] = out[j];
    out[j] = tmp;
  }
  return out;
}
